import styled from "styled-components";
import {PC_HORIZONTAL_SPACE_BETWEEN_ITEMS} from "../../../../../../basic-components/space-between-items-consts";


export const HybridEmbeddedGameLoadingIndicatorHeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    align-content: flex-end;
    width: 100%;
    padding: 4px ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS()} 4px 4px;
    
`